<template>
  <div class="cloud-floor-tab-components">
    <div class="floor-tab clearfix" v-if="tabList && tabList.length > 1">
      <div class="tab-item"
           :class="{active: currentTab && currentTab[0] && tab[0].storeyTabName === currentTab[0].storeyTabName}"
           v-for="(tab, index) in tabList" :key="index"
           @click="choiceTab(index)"
      >{{tab[0].storeyTabName}}
      </div>
    </div>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'CloudFloorTab',
  props: {
    floor: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      currentTab: [],
    }
  },
  computed: {
    tabList () {
      const temp = []
      if (this.floor?.fixedStoreyResourceEntityList?.length > 0) {
        temp.push(this.floor.fixedStoreyResourceEntityList)
      } else if (this.floor?.bannerResourceEntityList?.length > 0) {
        const obj = {}
        this.floor.bannerResourceEntityList.forEach(item => {
          if (obj[item.storeyTabName]) {
            obj[item.storeyTabName].push(item)
          } else {
            obj[item.storeyTabName] = [item]
          }
        })
        this.floor.videoResourceEntityList.forEach(item => {
          if (obj[item.storeyTabName]) {
            obj[item.storeyTabName].push({ isVideo: true, ...item })
          } else {
            obj[item.storeyTabName] = [{ isVideo: true, ...item }]
          }
        })
        for (const tab in obj) {
          temp.push(obj[tab])
        }
      } else if (this.floor?.bannerResourceEntityList?.length <= 0 && this.floor?.videoResourceEntityList?.length > 0) {
        const obj = {}
        this.floor.videoResourceEntityList.forEach(item => {
          if (obj[item.storeyTabName]) {
            obj[item.storeyTabName].push(item)
          } else {
            obj[item.storeyTabName] = [item]
          }
        })
        for (const tab in obj) {
          temp.push(obj[tab])
        }
      } else if (this.floor?.documentResourceEntityList?.length > 0) {
        const obj = {}
        this.floor.documentResourceEntityList.forEach(item => {
          if (obj[item.storeyTabName]) {
            obj[item.storeyTabName].push(item)
          } else {
            obj[item.storeyTabName] = [item]
          }
        })
        for (const tab in obj) {
          temp.push(obj[tab])
        }
      }
      return temp
    },
  },
  mounted () {
    if (this.tabList?.length > 0) {
      this.choiceTab(0)
    }
  },
  methods: {
    choiceTab (index) {
      this.currentTab = this.tabList[index]
      this.$emit('currentTab', {
        list: this.tabList[index],
        floorIndex: this.index,
      })
    },
  },
}
</script>

<style lang="scss">
.cloud-floor-tab-components {
  margin-top: 26px;
  width: 100%;

  .floor-tab {
    text-align: center;
    font-size: 0;

    .tab-item {
      display: inline-block;
      margin-right: 16px;
      line-height: 34px;
      padding: 0 16px;
      box-sizing: border-box;
      max-width: 128px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 34px;
      font-size: 16px;
      color: $--color-text-regular;
      font-weight: bold;
      border-radius: 17px;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        background: $--color-primary;
        color: #fff;
      }
    }
  }
}
</style>
